import React, { useEffect, useState } from 'react';
import { Table, Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { getNotificationHistory } from '../../Services/oneSignalService';

function NotificationList() {
  const { t } = useTranslation(); // Initialize the translation hook
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const data = await getNotificationHistory();
        setNotifications(data.notifications);
      } catch (error) {
        console.error(t('errorFetchingNotifications'), error); // Log with translation
      }
    };
    fetchNotifications();
  }, [t]);

  return (
    <Table responsive>
      <thead>
        <tr>
          <th>{t('title')}</th>
          <th>{t('message')}</th>
          <th>{t('sentAt')}</th>
          <th>{t('status')}</th>
          {/* <th>{t('actions')}</th> */}
        </tr>
      </thead>
      <tbody>
        {notifications.map((notification) => (
          <tr key={notification.id}>
            <td>{notification.headings.en}</td>
            <td>{notification.contents.en}</td>
            <td>{new Date(notification.queued_at * 1000).toLocaleString()}</td>
            <td>
              {notification.successful ? t('delivered') : t('failed')}
            </td>
            {/* <td>
              <Button color="primary" size="sm">{t('resend')}</Button>
            </td> */}
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

export default NotificationList;
